











































import { Component, Vue } from 'vue-property-decorator'
import adminPanelApi from '@/api/admin-panel'
import {OrganizationATableDto} from "@/global";

@Component({
})
export default class AdminPanel_Organizations extends Vue {
    table = {
        isLoading: false,
        currentPage: 1,
        totalCount: -1,

        fields: [
            {
                key: 'actions',
                label: ''
            },
            {
                key: 'shortName',
                label: 'Скорочена назва'
            },
            {
                key: 'fullName',
                label: 'Повна назва'
            },
            {
                key: 'telephonyServerName',
                label: 'Сервер телефонії'
            },
            {
                key: 'telephonyServerPhoneNumbersFirstPrefix',
                label: 'Префікс СМТЗ'
            },
            {
                key: 'telephonyServerPhoneNumbersSecondPrefix',
                label: 'Префікс організації'
            },
        ]
    };

    tableItemsProvider(ctx, callback: (items: OrganizationATableDto[]) => void) {
        this.table.isLoading = true;

        adminPanelApi.organizationsForTable(this.table.currentPage, result => {
            callback(result.items);

            this.table.totalCount = result.totalCount;
            this.table.isLoading = false;
        }, errorMessage => {
            callback([]);

            this.table.isLoading = false;
        });

        return null;
    }
}
